import { computed } from 'vue';
import { useInjectMenu } from './useMenuContext';
export default function useDirectionStyle(level) {
    const { mode, rtl, inlineIndent } = useInjectMenu();
    return computed(() => mode.value !== 'inline'
        ? null
        : rtl.value
            ? { paddingRight: `${level.value * inlineIndent.value}px` }
            : { paddingLeft: `${level.value > 1 ? (2 * inlineIndent.value + 14) : inlineIndent.value}px` });
}
